import {customElement} from "lit/decorators.js";
import {Resolution} from "../../../common/resolution";
import {resolve} from "../../../container";
import {ScrollService} from "../../../common/scroll";
import {EopExecutiveBoardGallery, executiveBoardGalleryConfig} from "./executiveBoardGallery";

@customElement("eop-executive-board-gallery-4")
export class EopExecutiveBoardGalleryFour extends EopExecutiveBoardGallery {

    public constructor(resolution: Resolution = resolve(Resolution), scrollService: ScrollService = resolve(ScrollService)) {
        // has duplicate in scss
        const portraitOnStageTimeline = [0.24, 0.48, 0.72, 0.96];
        const config = executiveBoardGalleryConfig(portraitOnStageTimeline, {portraitCount: 4, hasGroupShot: true});
        super(config, resolution, scrollService);
    }
}
